import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import VueI18n from "vue-i18n";
import en from "./locales/en.json";
import "bootstrap/scss/bootstrap.scss";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

Vue.use(VueI18n);

const messages = { en };

const i18n = new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || "en",
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en",
  messages,
});

Vue.config.productionTip = false;

const develop = process.env.NODE_ENV === "development";

const vueApp = new Vue({
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");

if (develop) {
  window.app = vueApp;
}
